<template>
  <div class="landing-page">
    <div class="top">
      <div class="map-container">
        <div
          class="background-map"
          :style="{
            backgroundImage: `url(${require(`../assets/images/home/map_placeholder.png`)})`
          }"
        ></div>
        <map-products></map-products>
      </div>
      <div class="content-container">
        <h1 class="text-gradient blue">
          {{ "landing_page.titles.main_title" | translate }}
        </h1>
        <h5 class="sub-title">
          {{ "landing_page.titles.sub_title" | translate }}
        </h5>
      </div>
    </div>

    <product-row
      :title_first="'landing_page.titles.selection' | translate"
      :title_second="'landing_page.titles.selection_small' | translate"
      see_more_link="Recommendations"
    ></product-row>

    <div class="stores gradient-bg-purple">
      <div class="title-with-see-more content-container">
        <div class="header-vertical-line">
          <div class="flex-col">
            <h4>{{ "landing_page.titles.selection" | translate }}</h4>
            <h4>{{ "landing_page.titles.selection_small" | translate }}</h4>
          </div>
        </div>
        <div @click="visitStoreMap" class="link arrow">
          {{ "landing_page.titles.see_more" | translate }}
        </div>
      </div>
      <div class="store-row-container content-container breakout">
        <div class="store-row">
          <div
            class="store-container"
            v-for="(store, i) in stores"
            :key="i"
            @click="visitStorePage(store.storeName)"
          >
            <div class="store-top">
              <img
                class="store-image"
                src="../assets/images/stores/lumi_accessories.jpg"
              />
              <h5 class="store-name">Store name</h5>
            </div>
            <div class="store-info">
              <div class="flex items-center">
                <div class="store-logo">
                  <img
                    src="../assets/images/store_logos/marita_huurinainen.png"
                  />
                </div>
                <div class="vertical-line"></div>
              </div>
              <div class="store-description">
                Here would be a good place to give a quick overview about the
                store and its products.
              </div>
              <div class="store-tags">
                <span class="tag black-bg">tagtag</span>
                <span class="tag black-bg">tag</span>
                <span class="tag black-bg">tagtag</span>
                <span class="tag black-bg">tag</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <featured-store
      image="fashion_placeholder"
      store_image="product_example"
      image_alignment="right"
      color="blue"
      store="lumi"
    ></featured-store>
    <featured-store
      image="fashion_placeholder"
      store_image="product_example"
      image_alignment="left"
      color="purple"
      store="lumi"
    ></featured-store>

    <product-row
      :title_first="'landing_page.titles.selection' | translate"
      :title_second="'landing_page.titles.selection_small' | translate"
      see_more_link="Recommendations"
      bg_color="gradient-bg-blue"
      :filter="{ type: 'shoes' }"
    ></product-row>

    <div class="brands content-container bg-black">
      <div class="title-with-see-more">
        <div class="header-vertical-line">
          <div class="flex-col">
            <h4>{{ "landing_page.titles.selection" | translate }}</h4>
            <h4>{{ "landing_page.titles.selection_small" | translate }}</h4>
          </div>
        </div>
        <div @click="visitRecommendationPage" class="link arrow">
          {{ "landing_page.titles.see_more" | translate }}
        </div>
      </div>
      <div class="brand-grid">
        <div class="brand-container" v-for="(brand, k) in brands" :key="k">
          <a>
            <p class="brand-list-link">{{ brand }}</p>
          </a>
        </div>
      </div>
    </div>
    <product-row
      :title_first="'landing_page.titles.selection' | translate"
      :title_second="'landing_page.titles.selection_small' | translate"
      see_more_link="Recommendations"
      sex="women"
      :filter="{
        sex: 'men',
        category: 'clothing',
        type: 'hoodie',
        store: ['centimeter']
      }"
      bg_color="gradient-bg-purple"
    ></product-row>
  </div>
</template>

<script>
import {
  applyFilter,
  getPossibleFilterValues,
  getSample,
  getStores
} from "../services/api";
import { errorHandling } from "../mixins";
import { mapMutations } from "vuex";
import MapProducts from "../components/molecules/map-products.vue";
import FeaturedStore from "../components/molecules/featured-store.vue";
import ProductRow from "../components/molecules/product-row.vue";

export default {
  name: "LandingPage",
  components: {
    MapProducts,
    FeaturedStore,
    ProductRow
  },
  mixins: [errorHandling],
  data() {
    return {
      selection: [],
      stores: [],
      brands: []
    };
  },
  methods: {
    visitRecommendationPage() {
      this.$router.push({ name: "Recommendations", params: { sex: "women" } });
    },
    visitProductMap() {
      this.$router.push({ name: "ProductMap" });
    },
    visitProductPage(product) {
      this.$router.push({
        name: "ProductPage",
        params: {
          name: product.name,
          id: product._id,
          sex: this.$route.params.sex
        }
      });
    },
    resolveStoreToLogo(store) {
      let url = `../assets/images/store_logos/${store}`;
      switch (store) {
        case "lumi_accessories":
          url += ".pdf";
          break;
        default:
          url += ".png";
          break;
      }
      return url;
    },
    visitStoreMap() {
      this.$router.push({ name: "stores" });
    },
    visitStorePage(storeName) {
      this.$router.push({ name: "StorePage", params: { store: storeName } });
    },
    visitBrandPage() {
      this.$router.push({ name: "brands" });
    },
    onLocateClick() {
      this.resetFilters();
      this.getSample();
      this.$router.push({ name: "ProductMap" });
    },
    async getSelection() {
      const response = await applyFilter({ numberOfItems: 20 });
      if (response.status === 201) {
        this.selection = response.data;
      } else {
        this.handleHttpError(response);
      }
    },
    async getStores() {
      const response = await getStores();
      if (response.status === 200) {
        this.stores = response.data;
      } else {
        this.handleHttpError(response);
      }
    },
    async getBrands() {
      const response = await getPossibleFilterValues("brand");
      if (response.status === 200) {
        const brands = response.data;
        brands.sort(() => Math.random() - 0.5);
        this.brands = brands.slice(0, 28);
      } else {
        this.handleHttpError(response);
      }
    },
    async getSample() {
      const response = await getSample();
      if (response.status === 200) {
        this.setProducts(response.data);
      } else {
        this.handleHttpError(response);
      }
    },
    ...mapMutations({
      resetFilters: "filters/reset"
    })
  },
  created() {
    this.getSelection();
    this.getStores();
    this.getBrands();
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.landing-page {
  min-height: 100vh;
}
.top {
  overflow: hidden;
  position: relative;
  height: 95vh;
  width: 100%;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .content-container {
    text-align: center;
  }

  .sub-title {
    color: white;
  }

  .map-container {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    z-index: -1;

    .background-map {
      background-size: cover;
      height: 100%;
      background-position: top;
      background-repeat: no-repeat;
      position: relative;

      &::after {
        content: "";
        background-color: $brand-gray;
        opacity: 0.3;
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
      }
    }
  }
}

.store-row-container {
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  .store-container:last-of-type {
    padding-right: 1rem;

    @media (min-width: $breakpoint-sm) {
      padding-right: 5%;
    }

    @media (min-width: $breakpoint-lg) {
      padding-right: 10%;
    }

    @media (min-width: $breakpoint-xl) {
      padding-right: 15%;
    }
  }
}

.stores {
  background-color: $gyra-grey-lightest;

  .store-row {
    display: flex;
    flex-direction: row;
  }

  .store-container {
    display: flex;
    flex-direction: column;
    margin-right: 3rem;
    cursor: pointer;

    .store-image {
      width: 17rem;
      border-top-left-radius: 1rem;
      border-top-right-radius: 1rem;

      @media (min-width: $breakpoint-sm) {
        width: 20rem;
      }
    }

    .store-top {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      &::after {
        content: "";
        background-color: $brand-gray-medium;
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        opacity: 0.3;
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
      }

      .store-name {
        position: absolute;
        font-family: "Montserrat-Bold";
        color: white;
        z-index: 2;
      }
    }

    .store-info {
      background-color: $brand-white;
      padding: 0.75rem;
      padding-top: 1rem;
      border-bottom-left-radius: 1rem;
      border-bottom-right-radius: 1rem;
      display: grid;
      grid-template-columns: auto 1fr;

      .store-description {
        margin-top: -0.25rem;
        margin-bottom: -0.25rem;
        font-size: $font-sm;
      }

      .store-logo {
        background-color: $brand-gray-medium;
        height: 3rem;
        width: 3rem;
        min-width: 3rem;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);

        img {
          width: 2rem;
        }
      }

      .vertical-line {
        width: 1px;
        height: 100%;
        background-color: $brand-black;
        margin: 0 0.5rem;
      }

      .store-tags {
        grid-column-end: 3;
        margin-top: 0.75rem;
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
}

.brands {
  padding-top: $m-s;
  padding-bottom: $m-s;

  .header-vertical-line {
    h4 {
      color: white;
    }

    &::before {
      background-color: white;
    }
  }

  .brand-grid {
    grid-template-columns: repeat(2, 1fr);
    display: grid;

    @media (min-width: $breakpoint-md) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: $breakpoint-lg) {
      grid-template-columns: repeat(4, 1fr);
    }

    .brand-container {
      padding-right: 1.5rem;
      padding-bottom: 1rem;
      overflow: hidden;

      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0;
      }
    }
  }
}
</style>
